export default __webpack_public_path__ + "static/media/IconWhatsapp.1cd55871.svg";